import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconColorDirective } from './icon-color.directive';
import { IconPaymentMethodPipe } from './icon-payment-method.pipe';
import { IconSizeDirective } from './icon-size.directive';

@NgModule({
  declarations: [IconColorDirective, IconSizeDirective, IconPaymentMethodPipe],
  imports: [CommonModule],
  exports: [IconSizeDirective, IconPaymentMethodPipe, IconColorDirective],
})
export class IconUiModule {}
